import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FormErrors } from 'validators/UserRegister3Validator2';
import { ActionBase } from 'store/ActionBase';
import { RegisterUserData, storeRegisterUserData2Generator } from 'store/register-user/RegisterUserData';
import { SiteDisplayItemsExtend } from 'hooks/UseSiteDisplayItems';
import { RoutePath } from 'consts/RoutePath';

/**
 * 新規会員登録3-2から4へ遷移する 次へ 処理のカスタムフック
 * フォームバリデーション -> 次へ実処理 を段階的に分けている
 * useStateが非同期なのでuseEffectを使って段階的にしないとエラーをキャッチすることができないため
 */
export const useNext = (
	formErrors: FormErrors,
	setFormErrors: React.Dispatch<React.SetStateAction<FormErrors>>,
	getErrorMessage: Function,
	formData: RegisterUserData,
	dispatch: React.Dispatch<ActionBase>,
	displayItems: SiteDisplayItemsExtend,
	setProcessLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
	// フォームバリデーション
	const [isFormValidationFinished, setIsFormValidationFinished] = useState(false);
	const next = () => {
		setProcessLoading(true);

		Object.keys(formErrors).forEach((k) => {
			setFormErrors((prev) => ({ ...prev, [k]: getErrorMessage(k, formData[k], displayItems[k]) }));
		});
		setIsFormValidationFinished(true);
	};

	// 次へ実処理
	const history = useHistory();
	useEffect(() => {
		if (!isFormValidationFinished) {
			return;
		}

		const isError = !!Object.values(formErrors).find((e) => e !== '');
		if (isError) {
			setIsFormValidationFinished(false);
			setProcessLoading(false);
			return;
		}

		// ストアに格納
		storeRegisterUserData2Generator(dispatch, formData);

		// 次のページへ
		history.push(RoutePath.USER_REGISTER_4, displayItems);
	}, [isFormValidationFinished]);

	return {
		next,
	};
};
